import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const Toast = MySwal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  },
});

export const showSuccessToast = (message) => {
  Toast.fire({
    icon: 'success',
    title: message,
  });
};

export const showErrorAlert = (message) => {
  MySwal.fire({
    icon: 'error',
    title: 'Oops...',
    text: message,
    confirmButtonColor: '#d33',
  });
};

// Dialog konfirmasi untuk aksi hapus
export const showConfirmDialog = () => {
  return MySwal.fire({
    title: 'Apakah Anda yakin?',
    text: "Data yang sudah dihapus tidak dapat dikembalikan!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Ya, hapus!',
    cancelButtonText: 'Batal',
  });
};